/*
 * @Author: young young@sinokru.com
 * @Date: 2023-10-11 12:10:08
 * @LastEditors: young young@sinokru.com
 * @LastEditTime: 2024-01-04 18:12:16
 * @FilePath: /fm_wx_store/src/api/base.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 接口域名的管理
 */
const base = {
  fm: "https://api.findmacau.com/fm",
  // fm: "https://api.findmacau.com/uat/fm",
  //  fm: "api",
  // fm: "http://192.168.25.57/uat/fm",
  bd: "http://hotelapi.findmcau.com/uat",
  
  // weChatRedirectUrl: 'http://localhost:8013'
  weChatRedirectUrl: "https://web.findmacau.com"
  // weChatRedirectUrl: "https://uatweb.findmacau.com"
};

export default base;



// WEBPACK FOOTER //
// ./src/api/base.js